export default __webpack_public_path__ + "static/media/IMG_4893.89d33f58.jpg";